<template>
  <div>
    <BaseToggle
      v-model="dynamicPricingMode"
      :label="$t('dynamic_pricing.mode.title')"
      :description="$t('dynamic_pricing.mode.description')"
      v-test="'enable-dynamic-pricing-mode'"
    />
  </div>
</template>

<script lang="ts">
import { storeToRefs } from 'pinia';
import { defineComponent } from 'vue';
import { useCalendarFiltersStore } from '@/stores/calendar-filters';

export default defineComponent({
  setup() {
    const { dynamicPricingMode } = storeToRefs(useCalendarFiltersStore());
    return {
      dynamicPricingMode,
    };
  },
});
</script>
